module.exports = {
  content: {
    errorPhoneNumber: "手机号码格式错误",
    successGetCode: "验证码获取成功",
    readAgree: "请阅读并同意服务协议",
    successLogin: "登录成功",
    successRegister: "注册成功",
    collectionSuccess: "收藏成功",
    cancelSuccess: "取消成功",
    pleaseLogin: "请先登录",
    changeSuccess: "修改成功",
    phoneWrong: "手机号格式错误请重新输入",
    unEmptyCode: "验证码不能为空",
    codeText: "获取验证码",
    cancelOrder: "订单取消成功",
    deleteOrder: "订单删除成功",
    confirmSuccessful: "确认收货成功",
    pleaseSales: "请先选择需要申请售后的商品",
    sellerShip: "已提醒卖家发货",
    paymentSuccessful: "支付成功！",
    cancelPayment: "确认取消支付？",
    questionDeleted: "请先选择需要删除的提问",
    answerDeleted: "请先选择需要删除的回答",
    delSucccess: "删除成功",
    pleaseContent: "请输入内容",
    successfulIntervention: "申请平台介入成功",
    recordDeleted: "请先选中需要删除的记录",
    isJPG: "上传图片只能是JPEG、JPG、PNG、BMP格式！",
    isLt5M: "上传图片大小不能超过5MB！",
    submittedSuccessfully: "提交成功",
    leastOneItem: "请至少选择一项",
    systemTips: "系统提示",
    deleteProduct: "您确定要从购物车中删除此产品吗？",
    cancel: "取消",
    confirm: "确定",
    info50: "您的购物车中有太多商品。 建议您在继续之前删除一些项目。",
    info100: "您购物车中的商品总数已达到上限。 请清理一些并继续添加到购物车。",
    cartEmptyTitle: "哎呀，您的购物车是空的！",
    cartEmptyContent: "您的购物车还是空的，从主页浏览有吸引力的产品。 ",
    shoppingNow: "立即购物",
    nostock: "抱歉，该产品缺货，请重新选择。",
    offline: "抱歉，该产品已下线。",
    invalid: "这是一个失效的产品。",
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/verify.js